/* src/app/shared/timesheet/status/timesheet-status.component.scss */
.timesheet-status-container {
  width: 90%;
  margin: 0 auto 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.timesheet-status {
  margin: 5px 0;
  text-align: center;
}
.timesheet-status select {
  padding: 3px 1.5rem 3px 1rem !important;
  border-radius: 10px;
  background: url("data:image/svg+xml,<svg height='10px' width='10px' viewBox='0 0 16 16' fill='%23000000' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>") no-repeat;
  background-position: calc(100% - 0.75rem) center !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  cursor: pointer;
}
.timesheet-status select:disabled {
  cursor: not-allowed;
}
.editable {
  background-color: #f3feed;
  border: solid 1px #87cd38;
  color: #87cd38;
}
.pre-final {
  background-color: #fefaed;
  border: solid 1px #fabf0d;
  color: #fabf0d;
}
.final {
  background-color: #FEEEED;
  border: solid 1px #CD3838;
  color: #CD3838;
}
/*# sourceMappingURL=timesheet-status.component.css.map */
